import { proxy } from 'valtio';
import { DEFAULT_PORTFOLIO_1, defaultNulls, defaultZeros, defaultHundreds, defaultGroups } from './build/Shared';

export const optimizationState = proxy({
  portName: DEFAULT_PORTFOLIO_1,
  products: defaultNulls.concat(),
  databases: defaultNulls.concat(),
  weights: defaultZeros.concat(),
  isValid: false,
  returnAssumption: null,
  timePeriod: null,
  optimizationGoal: null,
  targetReturn: 0,
  assetConstraint: false,
  groupConstraint: false,
  expectedReturns: defaultZeros.concat(),
  minWeights: defaultZeros.concat(),
  maxWeights: defaultHundreds.concat(),
  groups: defaultGroups.concat(),
  groupNames: {},
  groupMinWeights: {},
  groupMaxWeights: {},
  currency: null,
  rebalanceFreq: null,
  confidence: null,
  sdate: '',
  status: 'draft',
  notify: null,
  navigate: null,
  result: {},
});
